<template>
  <div>
    <div class="page-header scoped-header">
      <Row :gutter="30" type="flex" justify="space-between" style="flex-wrap: nowrap">
        <Col>
          <div class="page-header-title">
            {{ this.user.name }}，{{ $t('name.home.hello') }} {{ config.name }}
          </div>
          <div class="page-header-desc notice">
            {{ config.notice }}
          </div>
        </Col>
        <Col style="flex-shrink: 0; text-align: center">
          <Row :gutter="30" type="flex">
            <Col v-if="user_bill">
              <div class="title">
                {{ $t('name.home.user_bill_post') }}
              </div>
              <div class="body">
                {{ user_bill.post.count }}
              </div>
            </Col>
            <Col v-if="user_bill">
              <div class="title">
                {{ $t('name.home.user_bill_ok') }}
              </div>
              <div class="body">
                {{ user_bill.ok.count }}
              </div>
            </Col>
            <Col>
              <div class="title">
                {{ $t('name.home.ticket') }}
              </div>
              <div class="body">
                {{ ticket.count }}
              </div>
            </Col>
            <Col v-if="!user.hide_money">
              <div class="title">
                {{ $t('name.user.money') }}
              </div>
              <div class="body money">
                {{ user.money | money }}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
    <div class="page-content scoped-home">
      <Row :gutter="30">
        <Col :span="18">
          <div class="page-box">
            <div class="page-box-content">
              <div style="float:right">
                <RadioGroup v-model="cex_order_time" type="button" @on-change="getCexOrder">
                  <template v-for="(item, key) in $t('name.home.time')">
                    <Radio :label="key" :key="key">{{ item }}</Radio>
                  </template>
                </RadioGroup>
              </div>
              <div class="title">{{ $t('name.home.cex_order') }}</div>
              <Row :gutter="20" v-if="cex_order">
                <Col :span="8">
                  <div class="color-box">
                    <div class="icon pay">
                      <Icon type="md-time" size="50" />
                    </div>
                    <div class="body">
                      {{ $t('name.home.cex_order_pay') }}
                    </div>
                    <div class="count">
                      {{ cex_order.pay.count }}
                    </div>
                    <div class="money" v-if="!user.hide_money">
                      {{ cex_order.pay.money | money }}
                    </div>
                  </div>
                </Col>
                <Col :span="8">
                  <div class="color-box">
                    <div class="icon ok">
                      <Icon type="md-checkmark-circle-outline" size="50" />
                    </div>
                    <div class="body">
                      {{ $t('name.home.cex_order_ok') }}
                    </div>
                    <div class="count">
                      {{ cex_order.ok.count }}
                    </div>
                    <div class="money" v-if="!user.hide_money">
                      {{ cex_order.ok.money | money }}
                    </div>
                  </div>
                </Col>
                <Col :span="8">
                  <div class="color-box">
                    <div class="icon no">
                      <Icon type="md-power" size="50" />
                    </div>
                    <div class="body">
                      {{ $t('name.home.cex_order_no') }}
                    </div>
                    <div class="count">
                      {{ cex_order.no.count }}
                    </div>
                    <div class="money" v-if="!user.hide_money">
                      {{ cex_order.no.money | money }}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col :span="6" v-if="!user.hide_money">
          <div class="page-box">
            <div class="page-box-content" v-if="user_log">
              <div style="float:right">
                <RadioGroup v-model="user_log_time" type="button" @on-change="getUserLog">
                  <template v-for="(item, key) in $t('name.home.time')">
                    <Radio :label="key" :key="key">{{ item }}</Radio>
                  </template>
                </RadioGroup>
              </div>
              <div class="title">{{ $t('name.home.user_log') }}</div>
              <div class="tongji" style="margin-top: 10px">
                <div class="count" style="float: right">
                  {{ user_log.money | money }}
                </div>
                <div class="body">
                  {{ $t('name.home.user_log_money') }}
                </div>
                <Progress :percent="userLogMoney" :stroke-width="6" status="active" stroke-color="#ff9900" hide-info/>
              </div>
              <div class="tongji" style="margin-top: 25px">
                <div class="count" style="float: right">
                  {{ user_log.out_money | money }}
                </div>
                <div class="body">
                  {{ $t('name.home.user_log_out') }}
                </div>
                <Progress :percent="userLogOutMoney" :stroke-width="6" status="active" hide-info/>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { info } from '@/api/auth'
import { get } from '@/api/config'
import { ticket, userBill, cexOrder, userLog } from '@/api/total'

export default {
  data() {
    return {
      timer: null,
      user: {},
      config: {},
      ticket: {},
      user_bill: null,
      cex_order: null,
      cex_order_time: 0,
      user_log: null,
      user_log_time: 0
    }
  },
  computed: {
    userLogMoney() {
      let money = parseFloat(this.user_log.money)
      if (!money) return 0
      
      return money / (money + parseFloat(this.user_log.out_money)) * 100
    },
    userLogOutMoney() {
      let money = parseFloat(this.user_log.out_money)
      if (!money) return 0
      
      return money / (money + parseFloat(this.user_log.money)) * 100
    }
  },
  created() {
    this.getData()
    
    // 定时更新
    this.timer = setInterval(this.getData, 10000);
  },
  beforeDestroy() {
    // 取消定时
    clearInterval(this.timer);
  },
  methods:{
    getData() {
      // 用户信息
      info().then(res => {
        this.user = res
      })
      
      // 配置
      get().then(res => {
        this.config = res
      })
      
      // 发票
      ticket().then(res => {
        this.ticket = res
      })
      
      // 帐单
      userBill().then(res => {
        this.user_bill = res
      })
      
      this.getCexOrder()
      this.getUserLog()  
    },
    getUserLog() {
      userLog(this.user_log_time).then(total => {
        this.user_log = total
      })
    },
    getCexOrder() {
      cexOrder(this.cex_order_time).then(total => {
        this.cex_order = total
      })
    }
  }
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-header{
    padding: 60px 30px 30px;
    
    .notice{
      color: @color-warning;
    }
    
    .body{
      margin-top: 5px;
      color: @color-content;
      font-size: 25px;
      line-height: 35px;
      
      &.money{
        color: @color;
      }
    }
    
    .title{
      color: @color-sub;
      font-size: 14px;
      line-height: 20px;
    }
  }
  
  .scoped-home{
    .title{
      color: @color-content;
      font-size: 16px;
      line-height: 30px;
      padding-bottom: 20px;
    }
    
    .color-box{
      border: 1px @color-border solid;
      padding: 20px;
      border-radius: 5px;
      
      .icon{
        float:right;
        margin-top: 25px;
        opacity: .5;
        
        &.pay{
          color: @color;
        }
        
        &.no{
          color: @color-error;
        }
        
        &.ok{
          color: @color-success;
        }
      }
      
      .body{
        font-size: 14px;
        padding-bottom: 15px;
        color: @color-content;
      }
      .count{
        font-size: 30px;
        line-height: 35px;
        color: @color-title;
      }
      .money{
        font-size: 16px;
        color: @color-sub;
      }
    }
    
    .tongji{
      .count{
        color: @color-content;
        font-size: 20px;
        line-height: 30px;
      }
      
      .body{
        color: @color-sub;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
</style>